import { memo } from 'react';
import { useSelector } from 'react-redux';
import { PURE_WIRELESS_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { PureWirelessLayerControl } from './PureWirelessLayerControl';

interface RootState {
  sinatra: {
    irp: {
      irpVersion?: string;
    };
  };
}

/**
 * Controls for additional layers (internal partners, Pure Wireless, etc.)
 * These are layers that don't fit into GIS or Spatial Layer categories.
 */
export const AdditionalLayersControls = memo(() => {
  const irpVersion = useSelector(
    (state: RootState) => state.sinatra?.irp?.irpVersion,
  );

  const hasPureWireless = useHasCapability(
    PURE_WIRELESS_CAPABILITY,
  ).hasCapability;

  return (
    <div>
      {hasPureWireless && <PureWirelessLayerControl irpVersion={irpVersion} />}
    </div>
  );
});

export default AdditionalLayersControls;
